import api from '@/utils/api'

export const fetchPulseZones = (runner, params) => {
  return api.get(`/runners/${runner.id}/pulse_zones/`, {params: params})
    .then(resp => {
      return (resp.data)
    })
}
export const createPulseZones = (runner, obj) => {
  return api.post(`/runners/${runner.id}/pulse_zones/`, obj)
    .then(resp => {
      return (resp.data)
    })
}
export const updatePulseZones = (runner, obj) => {
  return api.put(`/runners/${runner.id}/pulse_zones/${obj.id}/`, obj)
    .then(resp => {
      return (resp.data)
    })
}

export const deletePulseZones = (runner, obj) => {
  return api.delete(`/runners/${runner.id}/pulse_zones/${obj.id}/`, obj)
    .then(resp => {
      return (resp.data)
    })
}



// WEBPACK FOOTER //
// ./src/physical_tests/api.js